import { create } from 'zustand';

interface SendOrderResponsiveOverlayStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useSendOrderResponsiveOverlay = create<SendOrderResponsiveOverlayStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
